// src/main.tsx

import './envShim.js'
import { Buffer } from 'buffer'

import { Amplify } from 'aws-amplify'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

import { setStorage } from './api/'
import { App } from './App'
import generatedGitInfo from './generatedGitInfo.json'

// Buffer global (für AWS SDK)
if (!window.Buffer) window.Buffer = Buffer

const {
  REACT_APP_ENV,
  REACT_APP_API_URL,
  REACT_APP_API_REGION,
  REACT_APP_S3_REGION,
  REACT_APP_S3_BUCKET,
  REACT_APP_COGNITO_REGION,
  REACT_APP_COGNITO_USER_POOL_ID,
  REACT_APP_COGNITO_APP_CLIENT_ID,
  REACT_APP_COGNITO_IDENTITY_POOL_ID,
} = import.meta.env

const { branch, commit_hash } = generatedGitInfo
const buildTimestamp = __BUILD_TIME__

console.log(
  `Build: ${branch}::${commit_hash}`,
  `env::${REACT_APP_ENV}`,
  'compiled:',
  buildTimestamp
)

setStorage('buildInfo', {
  environment: REACT_APP_ENV,
  build: buildTimestamp,
  branch,
  commit_hash,
})

// AWS Amplify konfigurieren (bewusst global)
Amplify.configure({
  Auth: {
    mandatorySignIn: true,
    region: REACT_APP_COGNITO_REGION,
    userPoolId: REACT_APP_COGNITO_USER_POOL_ID,
    identityPoolId: REACT_APP_COGNITO_IDENTITY_POOL_ID,
    userPoolWebClientId: REACT_APP_COGNITO_APP_CLIENT_ID,
  },
  Storage: {
    region: REACT_APP_S3_REGION,
    bucket: REACT_APP_S3_BUCKET,
    identityPoolId: REACT_APP_COGNITO_IDENTITY_POOL_ID,
  },
  API: {
    endpoints: [
      {
        name: 'karmaApi',
        endpoint: REACT_APP_API_URL,
        region: REACT_APP_API_REGION,
      },
    ],
  },
})

const rootElement = document.getElementById('root')
if (!rootElement) throw new Error('Root element with id="root" not found')

createRoot(rootElement).render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
)
